<template>
    <v-dialog
        :value="isOpen"
        max-width="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Zamówienia
                </h1>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="currentPlate.reportItemPlateOrders"
                :mobile-breakpoint="0"
                hide-default-footer
                disable-pagination
                name="reportItemPlateOrdersData"
            >
                <template #item.productName="{item}">
                    {{ parseEmptyValue(item.productName) }}
                </template>
            </v-data-table>
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import parse from '@/mixins/parse.js'

export default {
    name: 'OrdersListDialog',
    mixins: [
        parse
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        currentPlate: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            reportItemPlateOrders: [],
            headers: [
                {
                    text: 'Numer zamówienia',
                    value: 'orderNumber',
                    sortable: false
                },
                {
                    text: 'Produkt',
                    value: 'productName',
                    sortable: false
                },
            ]
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.reportItemPlateOrders = JSON.parse(JSON.stringify(this.currentPlate.reportItemPlateOrders.filter(order => order.isComplaint === true)))
            }
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>
